import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Solutions } from './components/Solutions';
import { WhatYouGet } from './components/WhatYouGet';
import { PricingSection } from './components/PricingSection';
import { TrustBadges } from './components/TrustBadges';
import { UrgencyCountdown } from './components/UrgencyCountdown';
import { BonusSection } from './components/BonusSection';
import { TestimonialGrid } from './components/TestimonialGrid';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { FAQSection } from './components/FAQSection';
import { FinalRecap } from './components/FinalRecap';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (!f.fbq) {
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    f.fbq('init', '896768146465042');
    f.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-white font-body text-black overflow-x-hidden selection:bg-orange/30 selection:text-black" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Solutions data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <PricingSection data-id="element-6" />
      <TrustBadges data-id="element-7" />
      <UrgencyCountdown data-id="element-8" />
      <BonusSection data-id="element-9" />
      <TestimonialGrid data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FinalRecap data-id="element-14" />
      <Footer data-id="element-15" />
    </main>;
}